/**
  系统管理--监控事件配置
 */
import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import { Modal, Button, message } from "antd";
import {
  EventMonitorCfgList,
  stubFaultReportedlevelData,
  autoEventMonitorCfg,
} from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import fetchHandler from "../../../fetch/fetchHandler";
import RefreshGrid from "../../../utils/refreshGrid";
import EventMonitorCfgUpdate from "./EventMonitorCfgUpdate";
import { useAuth } from "@/utils/utils";

// 国际化切换语言

/**
 * 引入设备状态列表
 */

// const TabPane = Tabs.TabPane;

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class WatchExcManage extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.watchExcManage;
    this.isAdd = this.internationalization.btn10;
    this.yunwei = this.props.intl.messages.commonBase;
    this.init();
    this.isFirst = true;
    this.hasSearch = false;
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      visible: false,
      xhList: [],
      formConfig: null,
      stubInfoData: null,
      tableParam: {
        stubGroupName: this.queryStubName,
        meterModuleId: this.queryMeterModuleId,
        stubId: this.queryStubId,
      },
      typeOption: [
        {
          text: this.props.intl.messages.commonBase.wz10, // '全部',
          value: "",
        },
      ],
      currentParam: {},
    };
  }

  /**
   * 页面加载前调用方法，初始化查询form表单
   */
  componentWillMount() {
    this.getLevel();
    /**
     * 初始化form查询表单
     */
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  /**
   * 页面加载完成调用方法，表格数据加载，并且初始化值
   */
  componentDidMount() {
    this.fetchApi(this.state.tableParam);
    this.setState({
      stubGroupName: "",
      meterModuleId: "",
      stubId: null,
      tableParam: {
        stubGroupName: "",
        stubGroupId: "",
        meterModuleId: "",
        stubId: "",
      },
    });
  }

  /**
   * 查询form表单初始化
   */
  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.title1, // '请输入:',
          param: {
            name: "eventName",
            type: "string",
          },
          labelName: this.internationalization.title2, // '事件名称',
          required: !1,
        },
        {
          type: "select",
          options: this.state.levelOption,
          placeholder: this.internationalization.title1, // '请选择:',
          param: {
            name: "levelId",
            type: "string",
          },
          labelName: this.internationalization.title4, // '运维等级',
          required: !1,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("901301")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.title5, // '查询'
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      defaultParams: {
        // stubGroupName: this.queryStubName,
        // powerBoxId: localStorage.meterModuleId,
        meterId: this.queryMeterModuleId,
        stubId: this.queryStubId,
      },

      context: this,
      tableKey: "stubSearchTable",
      tablePage: "监控事件管理",
    };
    return formConfig;
  };

  /**
   *
   * 表格初始化
   */
  init = () => {
    this.status = null;
    this.eventName = null;
    this.levelId = null;

    this.tableConfig = {
      tableKey: "stubSearchTable",
      tableColumns: [
        {
          name: this.internationalization.title2, // '事件名称',
          key: "eventName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: this.internationalization.title4, // '运维等级',
          key: "levelName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: this.internationalization.title6, // '创建时间',
          key: "craeteTime",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: this.internationalization.title7, // '监控范围',
          key: "cityName",
          colType: "textCol",
          align: "left",
          width: 200,
        },
        {
          name: "是否自动派单", // '',
          colType: "textCol",
          align: "left",
          width: 50,
          render: (value, row) => {
            const autoTicket = row.autoTicket;
            switch (autoTicket) {
              case 1:
                return "是";
              // break;
              case 2:
                return "否";
              // break;

              default:
                return <div>{row.eventRule}</div>;
              // break;
            }
          },
        },
        {
          name: this.internationalization.title8, // '监控范围',
          colType: "textCol",
          align: "left",
          width: 500,
          render: (value, row) => {
            const rule = JSON.parse(row.eventRule);
            const eventType = row.eventType;
            switch (eventType) {
              case 0:
                return <div>{"大于环境温度" + rule.environmentWeatherVal + "度"}</div>;
              // break;
              case 1:
                return <div>{"同组模块相差不能大于" + rule.maxSnVal}</div>;
              // break;
              case 2:
                return <div>{"不同品牌模块绝对值差" + rule.brandTVal}</div>;
              // break;
              case 3:
                return (
                  <div>
                    {"同组模块中电流最大最小差值大于" +
                      rule.maxAiVal +
                      ";" +
                      "异常采样点" +
                      rule.monitorPoint +
                      "个;" +
                      "异常订单数" +
                      rule.monitorOrder +
                      "单;"}
                  </div>
                );
              // break;
              case 4:
                return <div>--</div>;
              // break;
              case 5:
                return (
                  <div>
                    {"超过异常扣费金额" +
                      rule.exceptionPayVal +
                      ";" +
                      "或者充电量大于" +
                      rule.chargeNum +
                      "度且电费等于0;"}
                  </div>
                );
              // break;
              case 6:
                return (
                  <div>
                    {"连续异常订单（0 元订单）由" + rule.exceptionPayOrderNum + "位用户产生"}
                  </div>
                );
              // break;
              case 7:
                return <div>{"24小时掉线次数" + rule.offLineNum}</div>;
              // break;
              case 8:
                return <div>{"离线时长大于等于" + rule.offLineTime + "秒;"}</div>;
              // break;
              default:
                return <div>{row.eventRule}</div>;
              // break;
            }
          },
        },
        {
          name: this.internationalization.action, // '操作',
          key: "action",
          fix: "right",
          width: 320,
          colType: "action",
          actionMap: [
            useAuth("901302")
              ? {
                  type: "href",
                  actionName: "编辑",
                  handler: (record) => {
                    this.isAdd = this.internationalization.btn10;
                    this.setState({
                      seeStubStatusVisible: true,
                      stubId: record,
                    });
                  },
                }
              : "",
            useAuth("901303") || useAuth("901304")
              ? {
                  type: "confirm",
                  actionName: "开启自动派单",
                  render: (record) => {
                    return record.autoTicket == 2 ? "开启自动派单" : "关闭自动派单";
                  },
                  handler: (record) => {
                    fetchHandler(autoEventMonitorCfg, {
                      id: record.key,
                      status: record.autoTicket == 1 ? 2 : 1,
                    }).then((res) => {
                      if (res && (res.code === "ok" || res.code === "success")) {
                        message.success("操作成功");
                        RefreshGrid(this.context.store, "stubSearchTable");
                      }
                    });
                  },
                }
              : "",
          ],
        },
      ],
      tableParam: {
        pageCount: 10,
      },
      dataApi: EventMonitorCfgList,
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
  };

  /**
   * 页面内调用，关闭modal弹窗方法
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 传递给modal弹窗内组件子方法，关闭modal弹窗方法
   */
  cancelModal(key) {
    this.setState({
      [key]: false,
    });
  }

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
    // this.props.handle && this.props.handle()
  };

  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    const newParam = param;

    if (newParam.updateType === this.yunwei.wz10) {
      newParam.updateType = "";
    }

    if (newParam.frameWork === this.yunwei.wz10) {
      newParam.frameWork = "";
    }

    if (this.isFirst) {
      this.isFirst = false;
      newParam.stubGroupId = this.queryStubGroupId;
    } else {
      this.hasSearch = true;
      newParam.stubGroupId = "";
      param.stubGroupId = "";
    }
    this.setState({
      tableParam: param,
    });
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      this.setState({
        currentParam: newParam,
      });
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "stubSearchTable", newParam);
    }
  };

  // 获取故障等级
  getLevel() {
    fetchHandler(stubFaultReportedlevelData, {
      type: "2",
    }).then((res) => {
      // console.log(res);
      const list = res.data.map((item) => {
        const foo = {
          text: item.name,
          value: item.id,
        };
        return foo;
      });
      const first = {
        text: this.internationalization.all, // '全部',
        value: "",
      };
      list.unshift(first);
      this.setState(
        {
          levelOption: list,
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
      this.init();
    });
  }

  // 更新frameType
  updateFramType = () => {
    fetchHandler(EventMonitorCfgList, {
      stubId: this.stubInfoData.key,
    }).then((res) => {
      if (res && (res.code === "success" || res.code === "ok")) {
        this.setState({
          frameType: res.data[0].updateType,
          frameWork: res.data[0].frameWork,
        });
      }
    });
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable config={this.tableConfig} />
        </div>

        <Modal
          title={this.isAdd}
          visible={this.state.seeStubStatusVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => {
            this.modalVisibleAction("seeStubStatusVisible", false);
          }}>
          <EventMonitorCfgUpdate
            stubId={this.state.stubId}
            levelOption={this.state.levelOption}
            onCancel={() => {
              this.setState({ seeStubStatusVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "stubSearchTable");
            }}
          />
        </Modal>
      </div>
    );
    return Content;
  }
}

export default injectIntl(WatchExcManage);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/watchExcManage.js